import {useParams} from 'react-router-dom';

const useCustomParams = () => {
  const params = useParams();

  return params;
};

export default useCustomParams;
